/**
 * Labstep
 *
 * @module containers/Print
 * @desc Container to manage print progress
 */

import { selectPrintProgress } from 'labstep-web/state/new/print';
import type { LabstepReduxState } from 'labstep-web/state/types';
import { connect } from 'react-redux';
import type { WithPrintMapDispatchToProps } from './types';

const mapStateToProps = (
  state: LabstepReduxState,
): WithPrintMapDispatchToProps => ({
  progress: selectPrintProgress(state),
});

export const withPrint = <P extends WithPrintMapDispatchToProps, S>(
  Component: React.FC<P> | React.ComponentClass<P, S>,
): React.FC<
  Pick<P, Exclude<keyof P, keyof WithPrintMapDispatchToProps>>
> => connect(mapStateToProps)(Component as any);
